import type { JSX, ReactNode } from 'react';

export interface ActionGridItem {
  id: string;
  label: string;
  icon: ReactNode;
  onActivate: () => void;
}

/**
 * 3-column responsive grid of yellow-bordered action tiles. Used by both
 * Tools and Engineer Tools modals — same visual language, different
 * actions. Mirrors the existing product's modal-grid pattern.
 */
export function ActionGrid({ items }: { items: ActionGridItem[] }): JSX.Element {
  return (
    <ul className="action-grid" role="list" data-testid="action-grid">
      {items.map((item) => (
        <li key={item.id}>
          <button
            type="button"
            className="action-grid__item"
            onClick={item.onActivate}
            data-testid={`action-grid-${item.id}`}
          >
            <span className="action-grid__icon" aria-hidden>
              {item.icon}
            </span>
            <span className="action-grid__label">{item.label}</span>
          </button>
        </li>
      ))}
    </ul>
  );
}
